import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import { onMounted, ref } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import Prog_circular from "@/components/PrincipalComponents/Prog_circular.vue";
import SingleChart from "@/components/SmartLink/charts/SingleChart.vue";
import CompareCharts from "@/components/SmartLink/charts/CompareCharts.vue";

/********************************
 ********** CONSTANTES **********
 *******************************/
import { HEAD_WLAN } from "@/constants/tableHeaders";
import { STRING_GENERAL } from "@/constants/labels";
import { LABELS } from "@/constants/labels";
import { COLOR } from "@/constants/colors";

/********************************
 *********** SERVICES ***********
 *******************************/
import {
  getRajantDataByIP,
  getTempVoltDataByIP,
} from "@/services/Smartlink/Graphs";

/********************************
 ********** INTERFACES **********
 *******************************/
import { TEMP_VOLT_GRAPHS } from "@/interfaces/SmartLink/Equipos";


export default /*@__PURE__*/_defineComponent({
  __name: 'instameshGraphs',
  props: {
  ip: { required: true, type: String },
  // nameitem    : { required:true, type:String },
  typeitem: { required: true, type: String },
},
  setup(__props) {

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
const props = __props;

const params = { ip: props.ip };

/**
 * Capturamos los valores de la API: "getAllTempDataByIP"
 */
const getTempDataGraph = async () => {
  const allData = await getTempVoltDataByIP(params);

  if (allData.status === 400) {
    showTempVolt.value = allData.showGraphs;
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    showTempVolt.value = allData.showGraphs;
    allArrayTempVoltData.value = allData.data;
  }
};

const showTempVolt = ref({
  temp: false,
  volt: false,
});

const allArrayTempVoltData = ref<TEMP_VOLT_GRAPHS>({
  volt: [],
  temp: [],
});

const showGraphs = ref({
  wlan0: false,
  wlan1: false,
  wlan2: false,
  wlan3: false,
  wlanT: false,
  wired: false,
  cost: false,
});
const allArrayRajantData = ref({
  wlan0: { rx: [], tx: [], no: [] },
  wlan1: { rx: [], tx: [], no: [] },
  wlan2: { rx: [], tx: [], no: [] },
  wlan3: { rx: [], tx: [], no: [] },
  wired: { rx: [], tx: [] },
  wlanT: [],
  costs: [],
});

/**
 * captura los valores de la API: "getAllWirelessDataByIP"
 */
const getWirelessDataGraph = async () => {
  const allData = await getRajantDataByIP(params);

  if (allData.status === 400) {
    showGraphs.value = allData.showGraphs;
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    showGraphs.value = allData.showGraphs;
    allArrayRajantData.value = allData.data;
  }
};

onMounted(async () => {
  getTempDataGraph();
  getWirelessDataGraph();
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mx-1 mt-8" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          (showGraphs.value.wlan0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan0.no.length !== 0)
                        ? (_openBlock(), _createBlock(SingleChart, {
                            key: 0,
                            name: 'wlan0noise',
                            "first-array": allArrayRajantData.value.wlan0.no,
                            title: _unref(t)('title.noiseLevel') + ` < Wlan0 >`,
                            color: _unref(COLOR).single
                          }, null, 8, ["first-array", "title", "color"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showGraphs.value.wlan1)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan1.no.length !== 0)
                        ? (_openBlock(), _createBlock(SingleChart, {
                            key: 0,
                            name: 'wlan1noise',
                            "first-array": allArrayRajantData.value.wlan1.no,
                            title: _unref(t)('title.noiseLevel') + ` < Wlan1 >`,
                            color: _unref(COLOR).single
                          }, null, 8, ["first-array", "title", "color"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showGraphs.value.wlan2)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan2.no.length !== 0)
                        ? (_openBlock(), _createBlock(SingleChart, {
                            key: 0,
                            name: 'wlan2noise',
                            "first-array": allArrayRajantData.value.wlan2.no,
                            title: _unref(t)('title.noiseLevel') + ` < Wlan2 >`,
                            color: _unref(COLOR).single
                          }, null, 8, ["first-array", "title", "color"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showGraphs.value.wlan3)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 3,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan3.no.length !== 0)
                        ? (_openBlock(), _createBlock(SingleChart, {
                            key: 0,
                            name: 'wlan3noise',
                            "first-array": allArrayRajantData.value.wlan3.no,
                            title: _unref(t)('title.noiseLevel') + ` < Wlan3 >`,
                            color: _unref(COLOR).single
                          }, null, 8, ["first-array", "title", "color"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_sheet, {
        color: "transparent",
        width: "100%"
      }, {
        default: _withCtx(() => [
          (showTempVolt.value.temp)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayTempVoltData.value.temp.length !== 0)
                        ? (_openBlock(), _createBlock(SingleChart, {
                            key: 0,
                            name: 'temperature',
                            "first-array": allArrayTempVoltData.value.temp,
                            title: _unref(t)('labels.temperature'),
                            color: "#000000"
                          }, null, 8, ["first-array", "title"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showTempVolt.value.volt)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayTempVoltData.value.volt.length !== 0)
                        ? (_openBlock(), _createBlock(SingleChart, {
                            key: 0,
                            name: 'Voltage',
                            "first-array": allArrayTempVoltData.value.volt,
                            title: _unref(t)('labels.voltage'),
                            color: _unref(COLOR).green
                          }, null, 8, ["first-array", "title", "color"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showGraphs.value.cost)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.costs.length !== 0)
                        ? (_openBlock(), _createBlock(SingleChart, {
                            key: 0,
                            name: 'Cost',
                            "first-array": allArrayRajantData.value.costs,
                            title: _unref(t)('labels.cost'),
                            color: _unref(COLOR).green
                          }, null, 8, ["first-array", "title", "color"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (showGraphs.value.wired)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                class: _normalizeClass(_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph'),
                color: "bgtopology"
              }, {
                default: _withCtx(() => [
                  (allArrayRajantData.value.wired.rx.length !== 0)
                    ? (_openBlock(), _createBlock(CompareCharts, {
                        key: 0,
                        subtitle: '',
                        "name-primary": "rxGB",
                        "first-array": allArrayRajantData.value.wired.rx,
                        "color-first": _unref(COLOR).compare1,
                        "color-second": _unref(COLOR).compare2,
                        "name-secundary": "txGB",
                        "second-array": allArrayRajantData.value.wired.tx,
                        title: "Wired Tx - Rx [eth0]",
                        typeChart: _unref(STRING_GENERAL).instamesh
                      }, null, 8, ["first-array", "color-first", "color-second", "second-array", "typeChart"]))
                    : (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 1,
                        class: "text-center",
                        color: "transparent"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Prog_circular)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (showGraphs.value.wlanT)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 1,
            class: "pa-0",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "defaultCard"]),
                color: "bgtopology"
              }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "subtitleDashboard" }, "Clientes Wi-Fi", -1)),
                  (allArrayRajantData.value.wlanT.length > 0)
                    ? (_openBlock(), _createBlock(_component_EasyDataTable, {
                        key: 0,
                        "table-class-name": "customize-table",
                        "show-index": "",
                        headers: _unref(HEAD_WLAN),
                        items: allArrayRajantData.value.wlanT
                      }, null, 8, ["headers", "items"]))
                    : (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 1,
                        class: "text-center",
                        color: "transparent"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Prog_circular)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          (showGraphs.value.wlan0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                sm: "12",
                md: showGraphs.value.wlan1 ? 6 : 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan0.rx.length !== 0)
                        ? (_openBlock(), _createBlock(CompareCharts, {
                            key: 0,
                            subtitle: '',
                            "name-primary": "rxGB",
                            "first-array": allArrayRajantData.value.wlan0.rx,
                            "color-first": _unref(COLOR).compare1,
                            "color-second": _unref(COLOR).compare2,
                            "name-secundary": "txGB",
                            "second-array": allArrayRajantData.value.wlan0.tx,
                            title: "Wireless Tx - Rx [wlan0]",
                            typeChart: _unref(STRING_GENERAL).instamesh
                          }, null, 8, ["first-array", "color-first", "color-second", "second-array", "typeChart"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["md"]))
            : _createCommentVNode("", true),
          (showGraphs.value.wlan1)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan1.rx.length !== 0)
                        ? (_openBlock(), _createBlock(CompareCharts, {
                            key: 0,
                            subtitle: '',
                            "name-primary": "rxGB",
                            "first-array": allArrayRajantData.value.wlan1.rx,
                            "color-first": _unref(COLOR).compare1,
                            "color-second": _unref(COLOR).compare2,
                            "name-secundary": "txGB",
                            "second-array": allArrayRajantData.value.wlan1.tx,
                            title: "Wireless Tx - Rx [wlan1]",
                            typeChart: _unref(STRING_GENERAL).instamesh
                          }, null, 8, ["first-array", "color-first", "color-second", "second-array", "typeChart"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showGraphs.value.wlan2)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "12",
                sm: "12",
                md: showGraphs.value.wlan3 ? 6 : 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan2.rx.length !== 0)
                        ? (_openBlock(), _createBlock(CompareCharts, {
                            key: 0,
                            subtitle: '',
                            "name-primary": "rxGB",
                            "first-array": allArrayRajantData.value.wlan2.rx,
                            "color-first": _unref(COLOR).compare1,
                            "color-second": _unref(COLOR).compare2,
                            "name-secundary": "txGB",
                            "second-array": allArrayRajantData.value.wlan2.tx,
                            title: "Wireless Tx - Rx [wlan2]",
                            typeChart: _unref(STRING_GENERAL).instamesh
                          }, null, 8, ["first-array", "color-first", "color-second", "second-array", "typeChart"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["md"]))
            : _createCommentVNode("", true),
          (showGraphs.value.wlan3)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 3,
                cols: "12",
                sm: "12",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: _normalizeClass([_unref(xs) ? 'card-dialogs-graph-wop' : 'card-dialogs-graph', "mb-4"]),
                    color: "bgtopology"
                  }, {
                    default: _withCtx(() => [
                      (allArrayRajantData.value.wlan0.rx.length !== 0)
                        ? (_openBlock(), _createBlock(CompareCharts, {
                            key: 0,
                            subtitle: '',
                            "name-primary": "rxGB",
                            "first-array": allArrayRajantData.value.wlan3.rx,
                            "color-first": _unref(COLOR).compare1,
                            "color-second": _unref(COLOR).compare2,
                            "name-secundary": "txGB",
                            "second-array": allArrayRajantData.value.wlan3.tx,
                            title: "Wireless Tx - Rx [wlan3]",
                            typeChart: _unref(STRING_GENERAL).instamesh
                          }, null, 8, ["first-array", "color-first", "color-second", "second-array", "typeChart"]))
                        : (_openBlock(), _createBlock(_component_v_sheet, {
                            key: 1,
                            class: "text-center",
                            color: "transparent"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Prog_circular)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})